import clsx from 'clsx';
/**
 * Creates a string of classes for a flex container
 * @param options Flex options
 * @returns CSS classes
 */
export function getFlexClasses(options) {
    const { alignItems, justifyContent, wrap, column, inline } = options;
    return clsx(inline ? 'inline-flex' : 'flex', {
        'flex-col': column === true,
    }, {
        'justify-start': justifyContent === 'start',
        'justify-end': justifyContent === 'end',
        'justify-center': justifyContent === 'center',
        'justify-between': justifyContent === 'between',
        'justify-around': justifyContent === 'around',
        'justify-evenly': justifyContent === 'evenly',
    }, {
        'items-start': alignItems === 'start',
        'items-end': alignItems === 'end',
        'items-center': alignItems === 'center',
        'items-baseline': alignItems === 'baseline',
        'items-stretch': alignItems === 'stretch',
    }, {
        'flex-wrap': wrap === 'wrap',
        'flex-wrap-reverse': wrap === 'wrap-reverse',
        'flex-no-wrap': wrap === 'no-wrap',
    });
}
//# sourceMappingURL=getFlexClasses.js.map